import React from "react";
import ArquivosRoot from "./ArquivosRoot";
import UploadProvider from "../../contexts/UploadContext";

const Arquivos = () => {
  return (
    <UploadProvider>
      <ArquivosRoot />
    </UploadProvider>
  );
};

export default Arquivos;
